import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { FaStethoscope, FaFileMedicalAlt, FaFlask } from "react-icons/fa";
import { BottomNavbarContainer, NavItem } from "./localStyle";

const BottomNavbar = () => {
  const history = useHistory();
  const location = useLocation();

  let parsedConfig = {};
  try {
    parsedConfig = JSON.parse(localStorage.getItem("config")) || {};
  } catch (e) {
    parsedConfig = {};
  }

  const allNavItems = [
    {
      id: "consultas",
      label: "Consultas",
      icon: FaStethoscope,
      path: "/consultamedica",
      configKey: "opcConsultaMedica",
    },
    {
      id: "estudios",
      label: "Estudios",
      icon: FaFileMedicalAlt,
      path: "/estudios",
      configKey: "opcEstudios",
    },
    {
      id: "laboratorios",
      label: "Laboratorios",
      icon: FaFlask,
      path: "/laboratorio",
      configKey: "opcLaboratorio",
    },
  ];

  const navItems = allNavItems.filter(
    (item) => parsedConfig[item.configKey] !== false
  );

  const handleNavigation = (path) => {
    history.push(path);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <BottomNavbarContainer>
      {navItems.map((item) => {
        const Icon = item.icon;
        const active = isActive(item.path);

        return (
          <NavItem
            key={item.id}
            onClick={() => handleNavigation(item.path)}
            $isActive={active}
          >
            <div className="nav-icon">
              <Icon
                style={{
                  color: active ? "var(--color-white)" : "#999999",
                  fontSize: active ? "24px" : "20px",
                }}
              />
            </div>
            <span className="nav-label">{item.label}</span>
          </NavItem>
        );
      })}
    </BottomNavbarContainer>
  );
};

export default BottomNavbar;

